import SectionTitle from 'components/global/SectionTitle'
import { Col, Row, Section } from 'components/grid'
import { CoreAdoptionContext } from 'context/CoreAdoption'
import { StaticImage } from 'gatsby-plugin-image'
import React, { useContext } from 'react'
import { formatSectionId } from 'components/core-adoption/functions/formatSectionId'

export default function KnowledgeBuilding({ ...props }) {
	const { language } = useContext(CoreAdoptionContext)
	return (
		<Section margin="mt-20" id={formatSectionId(props)} className="scroll-mt-14">
			<SectionTitle
				title={language === 'english' ? 'Reading & Writing to Build Knowledge & Vocabulary' : 'Lectura y escritura para desarrollar conocimientos y vocabulario'}
			/>
			<Row center>
				<Col width="w-full md:w-3/4">
					{language === 'english' ? (
						<StaticImage src="../../../../static/images/core-adoption/build-knowledge.png" alt="Reading & Writing to Build Knowledge & Vocabulary" />
					) : (
						<StaticImage src="../../../../static/images/core-adoption/build-knowledge-spanish.png" alt="Reading & Writing to Build Knowledge & Vocabulary" />
					)}
				</Col>
			</Row>
		</Section>
	)
}
